<template>
  <button
    class="c-remove"
    :disabled="disabled"
    :aria-label="$t('ARIA.REMOVE_FILE')"
    :data-text="$t('MODAL.UPLOAD.FILE_REMOVE')"
  >
    <CloseIcon class="c-remove-icon" />
  </button>
</template>

<script setup lang="ts">
import CloseIcon from '@/assets/icons/CloseIcon.vue';

interface RemoveIconProps {
  disabled?: boolean;
}

withDefaults(defineProps<RemoveIconProps>(), {
  disabled: false,
});
</script>
